import { BreakpointSummaryTable } from './BreakpointSummaryTable/BreakpointSummaryTable';
import {
	TitleContainer,
	ValuationsLayout,
	ValuationsLoaderContainer,
} from '@dealstack/frontend/app/pages/Valuations/styled';
import { InlineLoader } from '@dealstack/frontend/shared/components/loaders/InlineLoader/InlineLoader';
import { SecurityOverrideDrawer } from '@dealstack/frontend/app/pages/Valuations/views/BreakpointSummary/SecurityOverride/SecurityOverrideDrawer';
import { InPageNavValuationsHeaderContainer } from '@dealstack/frontend/app/pages/Valuations/views/ValuationsHome/styled';
import { EntitySelectorDropdown } from '@dealstack/frontend/app/pages/Valuations/components/EntitySelectorDropdown/EntitySelectorDropdown';
import { AutoSaveIndicator } from '@dealstack/frontend/app/pages/Valuations/components/AutoSaveIndicator/AutoSaveIndicator';
import { DistributionRuleButton } from '@dealstack/frontend/app/pages/Valuations/views/BreakpointSummary/DistributionRule/DistributionRuleButton';
import { LinearSolveWarning } from '@dealstack/frontend/app/pages/Valuations/components/LinearSolveWarning/LinearSolveWarning';
import { Flex } from '@mantine/core';
import { useBreakpointSummaryView } from './useBreakpointSummaryView';

export const BreakpointSummary = () => {
	const {
		isSummaryFirstLoad,
		isBreakpointSummaryFirstLoad,
		isBreakpointSummaryLoading,
		breakpointSummaryData,
		currency,
		currentValuation,
		linearSolve,
		selectedPersonId,
		selectedMipId,
		selectedEntity,
		personOptions,
		availableTags,
		loadPerson,
		isDrawerOpen,
		selectedComponentInfo,
		handleOpenOverrideDrawer,
		handleCloseOverrideDrawer,
		handleSaveOverride,
		createOverride,
		updateOverride,
		deleteOverride,
		distributionRuleScope,
	} = useBreakpointSummaryView();

	if (isSummaryFirstLoad) {
		return (
			<ValuationsLoaderContainer>
				<InlineLoader withoutBackground />
			</ValuationsLoaderContainer>
		);
	}

	return (
		<>
			<ValuationsLayout>
				<InPageNavValuationsHeaderContainer>
					<TitleContainer>
						<EntitySelectorDropdown
							selectedPersonId={selectedPersonId}
							selectedMipId={selectedMipId}
							personOptions={personOptions}
							selectedEntity={selectedEntity}
							availableTags={availableTags}
							isLoadingPerson={isSummaryFirstLoad}
							loadPerson={loadPerson}
						/>
						<AutoSaveIndicator />
					</TitleContainer>
					<DistributionRuleButton
						isLoading={isBreakpointSummaryLoading}
						breakpointSummaryData={breakpointSummaryData}
						currency={currency}
						scope={distributionRuleScope}
					/>
				</InPageNavValuationsHeaderContainer>
				<Flex w="100%" direction="column" gap="1rem" sx={{ overflow: 'auto' }}>
					<LinearSolveWarning status={linearSolve} />
					{isBreakpointSummaryFirstLoad ? (
						<ValuationsLoaderContainer>
							<InlineLoader withoutBackground />
						</ValuationsLoaderContainer>
					) : (
						<BreakpointSummaryTable
							summaryData={breakpointSummaryData}
							currency={currency}
							onOpenOverrideDrawer={handleOpenOverrideDrawer}
							onDeleteOverride={deleteOverride}
						/>
					)}
				</Flex>
			</ValuationsLayout>

			{selectedComponentInfo && (
				<SecurityOverrideDrawer
					securityInfo={selectedComponentInfo}
					isOpen={isDrawerOpen}
					onClose={handleCloseOverrideDrawer}
					currency={currentValuation?.defaultCurrency}
					breakpointSummaryData={breakpointSummaryData}
					createOverride={async (data) => handleSaveOverride(() => createOverride(data))}
					updateOverride={async (overrideId, data) =>
						handleSaveOverride(() => updateOverride(overrideId, data))
					}
				/>
			)}
		</>
	);
};
